"use client"
/* */
const align = "flow--align";
const avatar = "flow--align--avatar";
const text = "flow--align--text";
const button = "flow--align--button";
const contextualHelpTriggerButton = "flow--align--contextual-help-trigger-button";
const copyButton = "flow--align--copy-button";
const icon = "flow--align--icon";
const styles = {
	align: align,
	avatar: avatar,
	text: text,
	button: button,
	contextualHelpTriggerButton: contextualHelpTriggerButton,
	copyButton: copyButton,
	icon: icon
};

export { align, avatar, button, contextualHelpTriggerButton, copyButton, styles as default, icon, text };
//# sourceMappingURL=Align.module.scss.mjs.map
